<template>
    <div class="anticancer">
        <home-skeleton v-if="skeleton" style="margin-top: 30px"></home-skeleton>
        <div v-else>
            <div class="anticancer-header">
                <div class="anticancer-header-title">
                    <van-image src="/static/bytx/anticancer/anticancer-header_title.svg" />
                </div>
                <div class="anticancer-header-title-tips">
                    <van-image src="/static/bytx/anticancer/anticancer-header_title_tips.svg" />
                </div>
                <div class="anticancer-header_bg-icon">
                    <van-image src="/static/bytx/anticancer/anticancer-header_bg-icon.svg" />
                </div>
                <!-- 搜索区域 -->
                <div class="anticancer-container-header">
                    <van-search
                        shape="round"
                        class="header-search"
                        @click="goSearch()"
                        v-model="value"
                        placeholder="搜一搜"
                        background="#30D6BEFF"
                    />
                </div>
            </div>

            <div class="anticancer-content">
                <div class="anticancer-content-main-box">
                    <van-grid column-num="3" active-color="#404040" v-model="active" :fixed="false" :border="false">
                        <van-grid-item @click="goList('knowledge-category', '疾病库', 1)" class="home-main-nav">
                            <van-image src="/static/bytx/new-home/home_head_icon_1@3x.png" />
                            <div class="title">疾病库</div>
                            <div>疾病详解 一看就懂</div>
                        </van-grid-item>
                        <van-grid-item @click="goList('curriculum', '医疗服务', 1)" class="home-main-nav">
                            <van-image src="/static/bytx/new-home/home_head_icon_2@3x.png" />
                            <div class="title">抗癌公开课</div>
                            <div>百科课程 一手掌握</div>
                        </van-grid-item>
                        <van-grid-item @click="goList('manual', '公益救助', 1)" class="home-main-nav">
                            <van-image src="/static/bytx/new-home/home_head_icon_3@3x.png" />
                            <div class="title">科普手册</div>
                            <div>权威手册 一键获取</div>
                        </van-grid-item>
                    </van-grid>
                </div>

                <div class="swipe">
                    <van-swipe :autoplay="3000" indicator-color="#fff">
                        <van-swipe-item v-for="item in banners" :key="item.id" @click="goBanner(item)">
                            <a
                                :href="
                                    item.target_url.replace(
                                        'https://bytx.care-gobroad.com',
                                        'https://bytx.care-gobroad.com'
                                    )
                                "
                            >
                                <img :src="item.img" alt="" />
                            </a>
                        </van-swipe-item>
                    </van-swipe>
                </div>
            </div>

            <div class="anticancer-container">
                <div class="anticancer-container-tabs-box">
                    <van-tabs v-model="active" sticky @click="onClick">
                        <van-tab
                            v-for="item in channelList"
                            :title="item.name"
                            :disabled="item.name == ''"
                            :key="item.id"
                            :name="item.id"
                        />
                    </van-tabs>
                    <div class="tav-more" @click="overlayShow = true">
                        <van-image src="/static/bytx/anticancer/tab-more.svg" />
                    </div>
                </div>

                <van-list
                    class="anticancer-container-wapper-list"
                    v-model="loading"
                    :finished="finished"
                    @load="onLoad"
                    finished-text="已经到底"
                >
                    <div v-for="(item, index) in channelContent" :key="index">
                        <Article v-if="item.origin_type === 2" :dataItem="item" />
                        <Videos v-else-if="item.origin_type === 3" :dataItem="item" />
                        <Lives v-else-if="item.origin_type === 4" :dataItem="item" />
                        <Knowledge v-else-if="item.type === 9" :dataItem="item" />
                        <Manual v-else-if="item.origin_type === 15" :dataItem="item" />
                        <Anticancer v-else-if="item.origin_type === 14" :dataItem="item" />
                    </div>
                </van-list>
                <van-empty
                    v-if="channelContent && channelContent.length == 0"
                    description=""
                    image="/static/img/pic_blank_content.svg"
                >
                    <template slot="description">
                        <div style="text-align: center">博医同行持续更新中…</div>
                        <div style="text-align: center;margin-top: 10px">先看看其他内容吧！</div>
                        <div style="text-align: center;margin-top: 24px">
                            <van-button color="#0FB7AD" round size="small" style="width: 120px" @click="$toHomePage">
                                返回首页
                            </van-button>
                        </div>
                    </template>
                </van-empty>
                <div class="clear"></div>
            </div>
        </div>

        <van-overlay class-name="anticancer-overlay" :show="overlayShow" @click="overlayShow = false">
            <div class="anticancer-overlay-wapper" @click.stop>
                <div class="anticancer-overlay-wapper-header">
                    <span>我的关注 <span>点击订阅你关注的内容吧</span></span>
                    <span class="selected" @click="onCustomMade">完成</span>
                </div>
                <div class="anticancer-overlay-wapper-nav">
                    <div
                        v-for="(item, index) in overlayUserList"
                        :key="index"
                        :class="[item.is_select === 1 ? 'active' : '']"
                        @click="handleNavigation(item)"
                    >
                        {{ item.name }}
                    </div>
                </div>
            </div>
        </van-overlay>

        <van-overlay class-name="manual-list-overlay" :show="manualOverlayShow" @click="manualOverlayShow = false">
            <div class="manual-list-overlay-content" @click.stop>
                <div class="manual-list-overlay-content-main">
                    <span>添加小助手</span>
                    <span class="selected">长按识别二维码，加小助手申领手册</span>
                    <van-image src="/static/bytx/anticancer/QR-code.svg" />
                    <van-image
                        class="close-icon"
                        src="/static/bytx/anticancer/close-icon.svg"
                        @click="manualOverlayShow = false"
                    />
                </div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
import Interface from '@/util/interface'
import homeSkeleton from '@/skeleton/homeSkeleton'
import { Manual, Anticancer, Lives, Videos, Article, Knowledge } from '@/components/contentSelection'

export default {
    components: {
        homeSkeleton,
        Manual,
        Anticancer,
        Lives,
        Videos,
        Article,
        Knowledge
    },
    data() {
        return {
            manualOverlayShow: false,
            active: '0',
            value: '',
            loading: true,
            finished: false,
            // isLoading: true,
            overlayShow: false,
            skeleton: false,
            banners: [],
            page: {
                page: 1,
                pageSize: 10
            },
            total: 0,
            channelList: [],
            overlayUserList: [],
            channelContent: [],
            record_id: 0
        }
    },
    methods: {
        onClick() {
            const params = {
                page: 1,
                pageSize: 10,
                channel_ids: this.active
            }
            Interface.getData('get', Interface.anticancer.channelContent, params).then(res => {
                this.channelContent = res.data.list
                this.total = res.data.total

                this.loading = false
                // this.isLoading = false

                if (this.channelContent.length >= this.total) {
                    this.finished = true
                }
            })
        },

        go_article_detail(item) {
            Interface.goArticle(this, item.id, item.type)
        },
        // 加载更多
        onLoad() {
            this.finished = false
            this.loading = true
            this.page.page++
            this.fetch('channelContent')
        },
        fetch(scene) {
            if (scene === 'channelList') {
                Interface.getData('get', Interface.anticancer.channelList).then(res => {
                    this.channelList = res.data.userlist.filter(val => val.is_select === 1)

                    if (this.channelList.length == 1) {
                        this.channelList = res.data.list
                    }

                    if (this.channelList.length < 5) {
                        for (let i = 999; i <= 1007 - this.channelList.length; i++) {
                            this.channelList.push({ name: '', id: i })
                        }
                    }

                    this.overlayUserList = res.data.list
                    this.skeleton = false
                })
            } else if (scene === 'channelContent') {
                const params = {
                    ...this.page,
                    channel_ids: this.active
                }
                Interface.getData('get', Interface.anticancer.channelContent, params).then(res => {
                    if (this.loading) {
                        this.channelContent = [...this.channelContent, ...res.data.list]
                    } else {
                        this.channelContent = res.data.list
                    }

                    this.total = res.data.total

                    this.loading = false
                    // this.isLoading = false

                    if (this.channelContent.length >= this.total) {
                        this.finished = true
                    }
                })
            } else if (scene === 'banner') {
                Interface.getData('get', Interface.anticancer.Banner, { type: 11 }).then(res => {
                    this.banners = res.data
                })
            }
        },
        async postChannelPost() {
            const params = {
                channel_ids:
                    this.overlayUserList
                        .filter(item => item.is_select === 1)
                        .map(item => {
                            return item.id
                        })
                        .toString() || '0'
            }
            await Interface.getData('post', Interface.anticancer.channelPost, params)
            this.fetch('channelList')
        },
        goList(row) {
            this.$router.push({
                name: row
            })
        },
        goPage(row) {
            console.log(row)
            this.$router.push({ name: row })
        },
        handleNavigation(row) {
            row.is_select = row.is_select === 1 ? 0 : 1
        },
        onCustomMade() {
            this.postChannelPost()

            this.overlayShow = false
        },
        goAnticancer(item) {
            Interface.goLink(item.content.link)
        },
        goBanner(item) {
          Interface.mFootPrint(item.id,62,0,3,0,0,0,item.title)
        },
        goSearch() {
          this.$router.push({ name: 'search', query: { pageType: 3 } })
          Interface.mFootPrint(0,76,0,3,0,0,0,'抗癌百科-搜索')
        }
    },
    created() {
        // const flag = localStorage.getItem('firstType')
        // if (!flag) {
        //     localStorage.setItem('firstType', 1)
        // }
        Interface.getShareInfo(this, '抗癌百科', '', '', 90, '',Interface.host + '/#/anticancer?source_type=1')
        let source_type = Interface.getUrl(window.location.href)
        if (source_type) {
          // Interface.mFootPrint(1, 90,0, 3, source_type, 0,0,'抗癌百科')
          Interface.getData('post',Interface.footprint, {
            id: 1,
            type: 90,
            content_type: 0,
            page_type: 3,
            source_type: source_type,
            parent_id: 0,
            record_id: 0,
            title: '抗癌百科'
          }).then( (res) => {
            if (res.code == 0) {
              this.record_id = res.data.record_id
            }
          })
        } else {
          // Interface.mFootPrint(1, 90,0, 3, 0, 0,0,'抗癌百科')
          Interface.getData('post',Interface.footprint, {
            id: 1,
            type: 90,
            content_type: 0,
            page_type: 3,
            source_type: 0,
            parent_id: 0,
            record_id: 0,
            title: '抗癌百科'
          }).then( (res) => {
            if (res.code == 0) {
              this.record_id = res.data.record_id
            }
          })
        }
        this.fetch('channelList')
        this.fetch('channelContent')
        this.fetch('banner')
        this.skeleton = true

        Interface.CoFootPrint(10)
    },
    beforeRouteLeave(to, from, next) {
      if (this.record_id) {
        Interface.mFootPrint(1, 90,0, 3, 0, 0,this.record_id,'抗癌百科')
      }
      next()
    }
}
</script>

<style lang="scss">
@import './index.scss';
</style>



// WEBPACK FOOTER //
// src/views/anticancer/index.vue